import {
    FaFacebookF,
    FaTwitter,
    FaInstagram,
    FaLinkedinIn,
    FaYoutube,
    FaWhatsapp
} from "react-icons/fa";

import "./Footer.css";

function Footer() {

    return (

        <footer className="footer">

            <div className="footer-top">

                <div className="footer-column">

                    <h3>Track My Order</h3>

                    <a href="/">
                        Where Is My Order?
                    </a>

                </div>

                <div className="footer-column">

                    <h3>Terms & Policies</h3>

                    <a href="/">
                        Terms Of Services
                    </a>

                    <a href="/">
                        Privacy Policy
                    </a>

                    <a href="/">
                        Shipping Policy
                    </a>

                    <a href="/">
                        Return & Refund Policy
                    </a>

                </div>

                <div className="footer-column">

                    <h3>Updates</h3>

                    <a href="/">
                        Blogs & Articles
                    </a>

                    <a href="/careers">
                        Careers
                    </a>

                </div>

                <div className="footer-column">

                    <h3>Help</h3>

                    <a href="/">
                        My Account
                    </a>

                    <a href="/">
                        Track Your Order
                    </a>

                    <a href="/contact-us">
                        Contact Us
                    </a>

                </div>

                <div className="footer-column">

                    <h3>About</h3>

                    <a href="/about-us">
                        About FarmFox
                    </a>

                </div>

            </div>

            <div className="footer-subscribe">

                <h4>
                    Don’t miss out on the latest offers
                </h4>

                <div className="whatsapp-form">

                    <input
                        type="text"
                        placeholder="Enter your WhatsApp number"
                    />

                    <button>
                        <FaWhatsapp />
                    </button>

                </div>

            </div>

            <div className="payment-section">

                <h4>We Accept</h4>

                <div className="payment-methods">

                    <span>GPay</span>
                    <span>•</span>

                    <span>Amazon Pay</span>
                    <span>•</span>

                    <span>VISA</span>
                    <span>•</span>

                    <span>MasterCard</span>
                    <span>•</span>

                    <span>BHIM UPI</span>
                    <span>•</span>

                    <span>RuPay</span>

                </div>

            </div>

            <div className="social-section">

                <h4>Follow Us!</h4>

                <div className="social-icons">

                    <a href="#">
                        <FaFacebookF />
                    </a>

                    <a href="#">
                        <FaTwitter />
                    </a>

                    <a href="#">
                        <FaInstagram />
                    </a>

                    <a href="#">
                        <FaLinkedinIn />
                    </a>

                    <a href="#">
                        <FaYoutube />
                    </a>

                </div>

            </div>

        </footer>

    );
}

export default Footer;